import { Card, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import CancelIcon from '@mui/icons-material/Cancel';

export const AddressCard = styled(Card)({
  borderRadius: '10px',
  height: '70px',
  width: '100%',
});

export const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  color: theme.palette.error.main,
  position: 'absolute',
  right: '0',
  top: '-15px',
}));

export const SadIcon = styled(SentimentDissatisfiedIcon)({
  color: 'gray',
  height: '100px',
  width: '100px',
});

export const CancelIconStyled = styled(CancelIcon)({
  height: '33px',
  width: '33px',
});
